import React, {Component } from 'react'
import axios from 'axios';

import { reactLocalStorage } from 'reactjs-localstorage';
import { toast } from 'react-toastify';

import { serverUrl , headerRequest, optProfileUser } from '../../lib/funApp/general';
import { avatar } from '../../lib/img/img';

import { Modal,} from "react-bootstrap";
import { Button, Card, Icon, Image } from 'semantic-ui-react';
import { Fab } from '@material-ui/core';
import { DeleteForever, LockOpen } from '@material-ui/icons';

import Loading from '../../containers/loading';

export default class UserDelete extends Component{

  constructor(props){
    super()
    this.user = props.user
    this.targetUrl = serverUrl + '/src/users/' + props.user._id
    this.state ={
      show: false,
      loading: false
    }
  }
  
  handleShow = () => this.setState({ show: !this.state.show });
  
  handleSubmit = () => {

    this.setState({ show: false, loading: true })

    axios.delete(this.targetUrl, {"headers" : headerRequest})
      .then(res => {
        if(res.status === 204){
          reactLocalStorage.set('@result', 204); 
          setTimeout(() => {
            return window.location.reload(false);
          }, 2000);
        }
      }).catch(error => {
          this.setState({ show: true, loading: false })
          toast.error('Erro Inesperado!!');
          console.log('ERROR: ', error.response.status + ' [' + error.response.data.message +']');
        }
      );
  }

  profileComp(profiles){

    function srcProfile(value) {
      let teste = ''
      optProfileUser.map((option, i)=>(
        option.value === value ? teste = option.text : false
      ))
      return teste
    }
    return(
      profiles.map((profile, i) =>(
        <span key={i}>
          <LockOpen style={{ color:'#2185d0' }} className="ml-1 mr-1"/> 
          <span>{srcProfile(profile)}</span>
        </span>
    )
   ))
  }

  render(){
    return(
      <>
      <Fab color="secondary" size="small" onClick={this.handleShow} title="Deletar Usuário" aria-label="add">
        <DeleteForever />
      </Fab>
      <Modal size="sm" show={this.state.show} onHide={this.handleShow} centered style={{backgroundColor: 'transparent !important' }}>
          <Card style={{ width: '100%' }}>
            <div className='m-3 text-center text-danger'>
              <h5><DeleteForever fontSize="large" className="mr-2" />Deseja Excluir o Usuário?</h5>
            </div>
            <Image  src={ this.user.gender === 'F' ? avatar.large.female[this.user.avatar] : avatar.large.male[this.user.avatar ? this.user.avatar : 0]} wrapped ui={false} />
            <Card.Content>
              <Card.Header className='m-2'>{this.user.name}</Card.Header>
              <Card.Meta className='m-2'>
                <span className='date'>{this.user.email}</span>
              </Card.Meta>
              <Card.Description className='m-4'>
                {this.profileComp(this.user.profiles)}
              </Card.Description>
            </Card.Content>
            <Card.Content extra className='text-center'>
              <Button.Group>
                <Button negative onClick={this.handleShow}>
                  <Icon name='remove' />Cancelar
                </Button>
                <Button.Or text='ou' />
                <Button positive basic={this.state.loading} loading={this.state.loading} onClick={this.handleSubmit} >
                  <Icon name='checkmark' />Excluir
                </Button>
              </Button.Group>
            </Card.Content>
          </Card>
      </Modal>
      { this.state.loading ? 
        <Loading />
      : false }
     </ > 
    )
  }
}
